import { createSlice } from "@reduxjs/toolkit";
import { StrandData } from "../../models/StrandData";
import { ProductionDataRow } from "../models/ProductionDataModel";

export interface ProductionManagementState {
	productionData: ProductionDataRow[];
	lastestHeats: any[];
	isLoading: boolean;
	error: string;
}

const ProductionManagementInitialState: ProductionManagementState = {
	productionData: [],
	lastestHeats: [],
	isLoading: false,
	error: "",
};

export const ProductionManagementReducer = createSlice({
	name: "__",
	initialState: ProductionManagementInitialState,
	reducers: {
		setProductionData(state, { payload }) {
			state.productionData = payload || [];
		},
		setLastestHeats(state, { payload }) {
			state.lastestHeats = payload || [];
		},
		setIsLoading(state, { payload }) {
			state.isLoading = payload;
		},
		setError(state, { payload }) {
			state.error = payload;
		},
	},
});
